import { AdornmentLeft } from './AdornmentLeft';

// TODO: in v9, move styled() from AdornmentLeft.jsx to here
export var StyledAdornmentLeft = AdornmentLeft;